<template>
  <div class="username-form m-0">
    <label
      :for="id"
      class="h-text-left pull-left pb-1 username-label m-0"
      :class="variant"
    >
      {{ label }}
    </label>

    <div class="w-100" :class="{ 'is-invalid': error }">
      <input
        class="new-username-input-modal"
        type="text"
        :autocomplete="autocompleteOff ? 'new-password' : 'on'"
        v-bind="{
          id,
          type,
          value,
          placeholder,
          tabindex,
          autofocus,
        }"
        @input="updateValue"
        @blur="onBlur"
        @focus="onFocus"
      />
    </div>
    <span
      v-show="(error, showError)"
      id="usernameHelp"
      class="form-text text-danger error-help"
      v-text="error"
    ></span>
  </div>
</template>
<script>
import { prop } from '@/utils/factories';

export default {
  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    },
  },
  props: {
    name: prop(String),
    id: prop(String, 'username-input'),
    label: prop(String),
    disabled: prop(Boolean),
    required: prop(Boolean),
    value: prop(String),
    type: prop(String, 'text'),
    error: prop(String),
    tabindex: prop(Number, -1),
    autofocus: prop(Boolean),
    placeholder: prop(String),
    variant: prop(String),
    autocompleteOff: prop(Boolean),
  },
  data() {
    return {
      showError: false,
    };
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
    onFocus() {
      this.$emit('focus');
      this.showError = false;
    },
    onBlur() {
      this.$emit('blur');
      this.showError = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.username-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: 'Alexandria', sans-serif !important;

  width: 100%;
  > div > .new-username-input-modal {
    display: flex;
    padding: 10px 12px 10px 16px;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
    align-self: stretch;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(255, 255, 255, 0.04);
    box-shadow: 0px 0px 24px 0px rgba(255, 255, 255, 0.04) inset;
    backdrop-filter: blur(2px);
    color: white;
    > input::placeholder {
      color: var(--opacity-800, rgba(255, 255, 255, 0.9));
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 150% */
      letter-spacing: -0.09px;
    }
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    border: 1px solid rgba(255, 255, 255, 0.06) !important;
    -webkit-text-fill-color: white !important;
    -webkit-box-shadow: 0px 0px 24px 0px rgba(255, 255, 255, 0.04) inset !important;
    transition: background-color 5000s ease-in-out 0s !important;
  }
  > .username-label {
    color: rgba(255, 255, 255, 0.5) !important;
    font-family: Alexandria !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 24px !important; /* 171.429% */
    letter-spacing: -0.18px !important;
  }
}
</style>
